export enum MENU_VIEW {
    MAXIMIZE = 'maximize',
    MINIMIZE = 'minimize',
}
